import {jwtDecode} from "jwt-decode";

export default function isJwtExpired(jwt) {
    try {
        const decoded = jwtDecode(jwt);
        return !jwt || !decoded || new Date(decoded.exp * 1000) < new Date();
    } catch (ex) {
        return true;
    }
}
